import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { MdCheckCircle, MdError, MdWarning } from 'react-icons/md'; // ⬅️ NOUVEAU
import { useTheme } from '../contexts/ThemeContext'; // ⬅️ NOUVEAU
import { THEME_COLORS, THEMES } from '../components/Constants'; // ⬅️ NOUVEAU


export default function VerificationStatusPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { currentTheme } = useTheme(); // ⬅️ NOUVEAU
    const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS[THEMES.BLUE]; // ⬅️ NOUVEAU

    const status = searchParams.get('status'); // 'success', 'failed', 'error'
    
    let title = '';
    let message = '';
    let icon = null;
    let color = themeColors.primary; // Couleur par défaut
    let buttonText = 'Aller à la page de connexion';
    let targetPath = '/';
    const REDIRECT_DELAY_MS = 8000; // 8 secondes de délai

    switch (status) {
        case 'success':
            title = 'Vérification Réussie !';
            message = 'Votre adresse e-mail a été confirmée avec succès. Vous pouvez maintenant vous connecter.';
            icon = <MdCheckCircle size={60} color={themeColors.success} />;
            color = themeColors.success;
            break;
        // 💡 NOUVEAU CAS : Changement d'email réussi
        case 'email_changed':
            title = 'Email mis à jour !';
            message = 'Votre nouvelle adresse e-mail a été confirmée. Pour des raisons de sécurité, veuillez vous reconnecter avec vos nouveaux identifiants.';
            icon = <MdCheckCircle size={60} color={themeColors.success} />;
            color = themeColors.success;
            buttonText = 'Se reconnecter';
            break;
        case 'failed':
            title = 'Lien Invalide';
            message = 'Le lien de confirmation est invalide ou a déjà été utilisé.';
            icon = <MdWarning size={60} color={themeColors.warning} />;
            color = themeColors.warning;
            break;
        case 'error':
            title = 'Erreur du Serveur';
            message = 'Une erreur inattendue est survenue lors de la vérification. Veuillez réessayer ultérieurement.';
            icon = <MdError size={60} color={themeColors.error} />;
            color = themeColors.error;
            break;
        default:
            title = 'Statut Inconnu';
            message = 'Nous ne pouvons pas déterminer le statut de votre vérification. Veuillez vous connecter.';
            icon = <MdWarning size={60} color={themeColors.warning} />;
            break;
    }

    // ⭐ Gestion de la Redirection Automatique
    React.useEffect(() => {
        if (status === 'success' || status === 'email_changed') {
            const timer = setTimeout(() => {
                navigate(targetPath);
            }, REDIRECT_DELAY_MS);
            return () => clearTimeout(timer); // Nettoyage du timer
        }
    }, [status, navigate, targetPath]);

    const handleNavigate = () => {
        navigate(targetPath);
    };


    return (
        <div style={styles.container(themeColors)}>
            <div style={{ color: color }}>{icon}</div>
            <h2 style={{ color: color, marginTop: '15px' }}>{title}</h2>
            <p style={{ color: themeColors.text, textAlign: 'center', marginBottom: '30px' }}>{message}</p>
            
            {status === 'success' && 
                <p style={{ color: themeColors.textSecondary, marginBottom: '15px', fontSize: '0.9em' }}>
                    Redirection automatique vers la page de connexion dans {REDIRECT_DELAY_MS / 1000} secondes...
                </p>
            }
            
            <button 
                onClick={handleNavigate} 
                style={styles.button(themeColors, color)}
            >
                {buttonText}
            </button>
        </div>
    );
}

const styles = {
    container: (colors) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '50px 20px',
        maxWidth: '500px',
        margin: '50px auto',
        backgroundColor: colors.mainBackground,
        borderRadius: '10px',
        boxShadow: `0 4px 12px ${colors.shadow}`,
        minHeight: '300px'
    }),
    button: (colors, statusColor) => ({
        marginTop: '10px',
        padding: '12px 20px',
        border: 'none',
        borderRadius: '4px',
        // Utilise la couleur primaire ou la couleur du statut si c'est un succès
        backgroundColor: statusColor === colors.success ? colors.success : colors.primary, 
        color: colors.textSecondary,
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '1em',
        transition: 'background-color 0.3s',
        // Note: La gestion du :hover se fait généralement via CSS standard ou des librairies de style
    }),
};